/**
 * The route manifest.
 *
 * A host registers the module's screens from this list rather than hard-coding them, so
 * adding a screen in a later slice does not require an edit in three host repositories.
 * There is no router in this package: the three MUI hosts are Next.js app-router and the
 * two Vite hosts are react-router 6, and a module that shipped either would be unusable in
 * the other. What travels is a description; the host does the mounting.
 *
 * `feature` is what the screen needs to be *useful*. It is a rendering hint for the
 * navigation, exactly like `FeatureGate` — invariant 7 means the server enforces it on
 * every request regardless, so a host that ignores this list is not creating a hole.
 */
import { AvailabilityScreen } from './screens/AvailabilityScreen.js';
import { GoodsIssueScreen } from './screens/GoodsIssueScreen.js';
import { GoodsReceiptScreen } from './screens/GoodsReceiptScreen.js';
import { ItemDetailScreen } from './screens/ItemDetailScreen.js';
import { ItemListScreen } from './screens/ItemListScreen.js';
import { StockEnquiryScreen } from './screens/StockEnquiryScreen.js';
export const INVENTORY_ROUTES = [
    {
        path: 'items',
        label: 'Items',
        description: 'The item master — one record per tenant, shared by every host application',
        component: ItemListScreen,
        feature: 'item_master',
        primary: true,
    },
    {
        path: 'items/:itemId',
        label: 'Item detail',
        description: 'One item, its balances by warehouse and its ledger',
        component: ItemDetailScreen,
        feature: 'item_master',
        primary: false,
        params: ['itemId'],
    },
    {
        path: 'stock',
        label: 'Stock enquiry',
        description: 'Balances by item, warehouse and state, with the ledger behind them',
        component: StockEnquiryScreen,
        feature: 'stock_enquiry',
        primary: true,
    },
    {
        path: 'availability',
        label: 'Availability',
        description: 'On hand, held hard, held soft, issuable and available-to-promise',
        component: AvailabilityScreen,
        feature: 'stock_reservation',
        primary: true,
    },
    {
        path: 'receipts/new',
        label: 'Goods receipt',
        description: 'Post stock in, with a per-unit cost',
        component: GoodsReceiptScreen,
        feature: 'stock_ledger',
        primary: true,
    },
    {
        path: 'issues/new',
        label: 'Goods issue',
        description: 'Post stock out, checked against issuable',
        component: GoodsIssueScreen,
        feature: 'goods_issue',
        primary: true,
    },
];
/** The base path the module expects to own, by convention. Hosts may override. */
export const INVENTORY_BASE_PATH = '/inventory';
//# sourceMappingURL=routes.js.map